module.exports = __webpack_public_path__ + "img/congresso.baf732de.png";